import { render, staticRenderFns } from "./VueMenuItem.vue?vue&type=template&id=bc1d8d0e"
import script from "./VueMenuItem.vue?vue&type=script&lang=js"
export * from "./VueMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports